import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "excess" }
const _hoisted_2 = { class: "excess-bottom-twoBtnBox" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-jiluwenben" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "创作版权说明 ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  style: {"text-decoration":"none","color":"#606266"},
  href: "https://ai.cemeta.cenmetahome.cn/"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-guanyu" }),
  /*#__PURE__*/_createElementVNode("span", null, "关于CeMeta")
], -1)

import Header from '../components/Header.vue';
//引导页
import Excess from '../components/updata/Excess.vue';
//生成页面
import Generate from '../components/updata/Generate.vue';
//上传视频页面
import Upload from '../components/updata/Upload.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import {useRouter} from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

//头部组建
const router=useRouter();
const store=useStore();
const isShowName = computed(()=>{
    // console.log(store.state)
    return store.state.comShow.componentsShow;
});
const updataShow = (name:string) => {
    store.commit('comShow/upDataShow', name);
};
const toCreate=()=>{
    router.push('/create');
};


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, { onUpdataShow: updataShow }),
    (_unref(isShowName) == 'Excess')
      ? (_openBlock(), _createBlock(Excess, {
          key: 0,
          onUpdataShow: updataShow
        }))
      : (_unref(isShowName) == 'Generate')
        ? (_openBlock(), _createBlock(Generate, { key: 1 }))
        : (_openBlock(), _createBlock(Upload, { key: 2 })),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, { onClick: toCreate }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, null, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}
}

})